import { createContext, useContext } from "react";

/**
 * Yuvayı DIŞARIDAN açma isteği.
 *
 * `nonce`, isteğin KENDİSİNİ taşıyor, hedefi değil: aynı konuşmaya ikinci kez basmak yeni bir
 * sayı üretiyor ve etki yeniden çalışıyor. Yalnız hedefe bakan bir etki, kullanıcı yuvayı kapatıp
 * aynı düğmeye tekrar bastığında hiçbir şey yapmazdı.
 */
export interface ChatDockOpenRequest {
  /**
   * Açılacak konuşma. YOKSA ve kişi de yoksa yuva «yeni sohbet» kipinde açılıyor: canlı yardım
   * düğmesi destek kişisi tanımlı olmadığında kullanıcıyı sayfadan koparmasın diye.
   */
  conversationId?: string | undefined;
  /**
   * Konuşma AÇMADAN o kişiyle yazmaya başlamak: liste satırı ve yazma alanı görünüyor, sunucuda
   * ise hiçbir şey yok. O kişiyle zaten bir konuşma varsa taslak açılmıyor, var olan açılıyor.
   */
  draftUserId?: string | undefined;
  /** Taslağın adı, çağıran biliyorsa (rehber kartı). Bilmiyorsa rehberden çözülüyor. */
  draftName?: string | undefined;
  nonce: number;
}

export type ChatDockTarget = Omit<ChatDockOpenRequest, "nonce">;

export interface ChatDockContextValue {
  request: ChatDockOpenRequest | null;
  openDock: (target?: ChatDockTarget) => void;
  /**
   * İsteği TÜKETİR: yuva işlediği isteği sağlayıcıdan siler.
   *
   * İstek bir OLAY, durum değil. Tüketilmeyen istek sağlayıcıda kalıyordu ve yuvanın etkisi
   * başka bir sebeple yeniden koştuğunda (sohbet sayfasına gidip dönmek) kapatılmış yuva aynı
   * istekle KENDİLİĞİNDEN yeniden açılıyordu — kitin «kendiliğinden açılma» yasağı. Yalnız bu
   * `nonce` hâlâ bekleyen istekse silinir: arada gelen yeni bir basış kaybolmaz.
   */
  consume: (nonce: number) => void;
}

export const ChatDockContext = createContext<ChatDockContextValue | null>(null);

/** Sağlayıcının dışında `null`: çağıran o durumda sohbet sayfasına gitmeyi seçebilir. */
export function useChatDock(): ChatDockContextValue | null {
  return useContext(ChatDockContext);
}
